import React, { Component } from 'react';
import 'semantic-ui-css/components/grid.min.css';
import './StoreHours.css';
import { LocalStoreIconClicked } from '../../../utils/Analytics';
import { getStoreId, singaporeStoreId } from '../../../utils/StoreConfigManager';

const storeId = getStoreId();

const StoreHours = ({ className, isCentered, color, storeHoursStyling, fontSize = '10' }) => {
    const redirect = () => {
        const link = singaporeStoreId === storeId ? 'https://www.fendi.com/sg-en/store-locator/singapore?utm_source=ObsessVR&utm_medium=referral&utm_campaign=SGMBS_Virtual_Store' : 'https://www.fendi.com/us/store-locator';
        LocalStoreIconClicked(link)
        window.open(link, '_blank')
    }

    return (
        <div className="store-hours-to-order" style={{ color: color, ...storeHoursStyling }}>
            {singaporeStoreId === storeId && <>
                <div className="store-hours-text" style={{ fontSize: '12px' }}>{`Fendi Marina Bay Sands Boutique`}</div>
                <div className="store-hours-text" style={{ fontSize: fontSize }}>&nbsp; {`Sunday-Saturday 11:00 - 22:00 GMT +8`}</div>
            </>}
            {singaporeStoreId !== storeId && <>
                <div className="store-hours-text" style={{ fontSize: '12px' }}>{`Fendi 57th Street Flagship`}</div>
                <div className="store-hours-text" style={{ fontSize: fontSize }}>&nbsp; {`Mon-Sat 11 am – 8 pm EST`}</div>
                <div className="store-hours-text" style={{ fontSize: fontSize }}>&nbsp; {`Sun 11 am – 6 pm EST`}</div>
            </>}
            {<div className="store-hours-text" style={{ fontSize: fontSize }}>or contact your local boutique <span className="local-store-link" style={{ color: color }} onClick={redirect}> Store locator </span></div>}
        </div>
    )
}

export default StoreHours;